import classNames from "classnames";
import scss from "@/styles/pages/contact-us/details.module.scss";

export const wrapper = classNames(
    // Mobile
    "mobile:p-5",
    // Tablet
    "tablet:p-30",
    scss["wrapper"]
);

export const details = classNames(
    // Mobile
    "mobile:mt-8",
    // Tablet
    "tablet:mt-16",
    "flex",
    "flex-col",
    "items-center",
    "justify-center"
);
export const detailItem = classNames(
    // Mobile
    "mobile:text-lg",
    // Tablet
    "tablet:text-2xl",
    // All
    "flex",
    "items-center",
    "justify-start",
    "mb-5",
);
export const icon = classNames("w-6", "mr-6");
export const strong = classNames("mr-6", "font-semibold");


